import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  validateInss(inss: string) {
    if (inss === undefined) {
      return false;
    }
    inss = inss.replace(/[.-]/g, '');

    if (inss === null || inss.length === 0) {
      return false;
    }

    if (inss.length !== 11) {
      return false;
    }

    let numberCheck = parseInt(inss.substring(0, 9), 10);
    const digitCheck = parseInt(inss.substring(9), 10);

    // Special check for people from the 21st century
    const year = new Date().getFullYear() - 2000;
    if (numberCheck < year * 10000000) {
      numberCheck += 2000000000;
    }

    return (97 - numberCheck % 97 === digitCheck);
  }
}
